//libs
import React from 'react';
import useTimer from './useTimer';

const Timer = ({
  countDownTime,
  className = '',
  offerTimeDiff,
  setIsExpired,
  dataTestId = 'coupon-timer',
  showDays = false,
}: {
  countDownTime: number;
  className?: string;
  offerTimeDiff?: number;
  setIsExpired?: (hasExpired: boolean) => void;
  dataTestId?: string;
  showDays?: boolean;
}) => {
  const { timeRemaining = '' } = useTimer({
    initTime: offerTimeDiff || countDownTime,
    setIsExpired,
    showDays,
  });

  return (
    <span className={className} data-test={dataTestId}>
      {timeRemaining}
    </span>
  );
};

export default Timer;
